import React from 'react';
import { Testimonial } from './ui/design-testimonial';

const Testimonials = ({ items }) => {
  if (items && !items.length) return null;
  return <Testimonial items={items} />;
};

export default Testimonials;
